import React from 'react';
import styled, { css } from 'styled-components';
import { CheckboxWrapper } from './CheckboxWrapper';
import { CheckboxGroup } from '../../Checkbox';
import { AddRemoveAllButton } from './AddRemoveAllButton';
const MultiSelectMenuOptionsBox = styled.div(({ theme: { colors, space }, $isOpen, offsetHeight }) => css `
    position: absolute;
    width: 100%;
    z-index: 1;
    padding: ${space.sm} ${space.md} ${space.xxs} ${space.md};
    border-radius: 0 0 4px 4px;
    border: 1px solid ${colors['gray-300']};
    box-shadow: 0 5px 8px -4px rgba(0, 0, 0, 0.16),
      0px 2px 4px -2px rgba(0, 0, 0, 0.16);
    background-color: ${colors.white};
    height: fit-content;
    max-height: ${offsetHeight ? `${offsetHeight + 500}px` : 'none'};
    overflow: clip;
    transition: max-height 250ms ease-out;
    ${!$isOpen
    ? css `
          max-height: 0;
          transition: max-height 0.25s ease-out, visibility 0.25s ease-out;
          visibility: hidden;
        `
    : css ``}
  `);
const StyledCheckboxGroup = styled(CheckboxGroup)(({ theme: { space } }) => css `
    padding-bottom: ${space.md};
  `);
const MultiSelectMenuOptions = ({ options, values, onChange, optionValues, isOpen, label, checkboxRef, getAddRemoveButtonAriaDescribedBy, getAriaLiveAddRemoveAll, getAddRemoveAllButtonText, }) => {
    var _a, _b;
    const handleOnChange = (e) => {
        const { checked, name } = e.target;
        if (checked)
            values.add(name);
        if (!checked)
            values.delete(name);
        onChange(Array.from(values));
    };
    const selectMenuBoxRef = React.useRef(null);
    const offsetHeight = (_a = selectMenuBoxRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
    const checkboxGroupChildren = ((_b = selectMenuBoxRef.current) === null || _b === void 0 ? void 0 : _b.children) || [];
    const childrenArray = Array.from(checkboxGroupChildren).filter(e => e instanceof HTMLLabelElement);
    const getHandleOnKeyDown = React.useCallback((prevIndex, nextIndex) => (e) => {
        const isPrev = ['ArrowUp', 'ArrowLeft'].includes(e.key);
        const isNext = ['ArrowDown', 'ArrowRight'].includes(e.key);
        if (isPrev) {
            childrenArray[prevIndex].focus();
        }
        if (isNext) {
            childrenArray[nextIndex].focus();
        }
    }, [childrenArray]);
    return (React.createElement(MultiSelectMenuOptionsBox, { "$isOpen": isOpen, offsetHeight: offsetHeight, "aria-hidden": isOpen ? 'false' : 'true' },
        React.createElement(StyledCheckboxGroup, { legendText: label, ref: selectMenuBoxRef, isSROnly: true }, options.map(({ label: optionLabel, value, isDisabled: disabled }, index) => {
            const safeValue = String(value);
            const isChecked = values.has(safeValue);
            const firstIndex = 0;
            const lastIndex = options.length - 1;
            const isFirst = index === firstIndex;
            const isLast = index === lastIndex;
            const nextIndex = isLast ? firstIndex : index + 1;
            const prevIndex = isFirst ? lastIndex : index - 1;
            const handleOnKeyDown = getHandleOnKeyDown(prevIndex, nextIndex);
            return (React.createElement(CheckboxWrapper, Object.assign({ label: optionLabel, name: safeValue, isDisabled: disabled, onChange: handleOnChange, isChecked: isChecked, handleOnKeyDown: handleOnKeyDown, key: `${optionLabel}_${value}` }, (isFirst ? { ref: checkboxRef } : {}))));
        })),
        React.createElement(AddRemoveAllButton, { values: values, optionValues: optionValues, onChange: onChange, getAddRemoveButtonAriaDescribedBy: getAddRemoveButtonAriaDescribedBy, getAriaLiveAddRemoveAll: getAriaLiveAddRemoveAll, getAddRemoveAllButtonText: getAddRemoveAllButtonText })));
};
export { MultiSelectMenuOptions };
//# sourceMappingURL=MultiSelectMenuOptions.js.map